var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-dialog',{ref:"modal"},[_c('q-card',{staticClass:"q-pa-lg"},[_c('h6',{staticClass:"text-center q-py-md"},[_vm._v(" "+_vm._s(_vm.content)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }